import React, { useState } from "react";
import Badge from "@mui/material/Badge";
import { Image } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./sharedUnits.css";
import VideoPlayer from "./VideoPlayer";
import VirtualTourRenderer from "./VirtualTourRenderer";

const SharedPropertyCardMobile = ({
  data = {},
  parseAvailabilityDate = () => {},
  handleNotesModalOpen = () => {},
  updateFavorite = () => {},
  hideUnits = () => {},
}) => {
  const { units = {} } = data;
  const { property = {} } = units;

  const [swiperInstance, setSwiperInstance] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 2;

  const { date, month } = parseAvailabilityDate(
    units?.unit_availability_text || ""
  );

  const utcDate = new Date(data?.created_at || "");
  const options = { year: "numeric", month: "long", day: "numeric" };
  const localDate = utcDate.toLocaleDateString(undefined, options);

  return (
    <div className=" w-full  text-[#596962] bg-white max-w-lg">
      <div className="flex flex-col">
        {/* Property Added Date */}
        <p className="text-gray-500 text-sm italic my-1 text-center">
          {`Property added on ${localDate || ""}`}
        </p>

        {/* Main Content */}
        <div className="gap-4 min-h-64 bg-[#EBE6DE] rounded-lg rounded-b-3xl">
          {/* Top Section - Main Image */}
          <div className="relative">
            <div className="relative w-full h-64 overflow-hidden bg-white border rounded-xl">
              <Swiper
                spaceBetween={20}
                slidesPerView={1}
                onSwiper={setSwiperInstance}
                onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
                className="w-full h-full"
              >
                <SwiperSlide>
                  {!units?.floor_plan_video ? (
                    <Image
                      height={"100%"}
                      width={"100%"}
                      src={units?.floor_plan || ""}
                      fallback="data:image/png;base64,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"
                      alt="Thumbnail"
                      className="w-full h-full object-cover rounded-md"
                    />
                  ) : units?.floor_plan_video &&
                    units?.floor_plan_video?.includes("videoUrl") ? (
                    <VideoPlayer data={units?.floor_plan_video} />
                  ) : (
                    <VirtualTourRenderer data={units?.floor_plan_video} />
                  )}
                </SwiperSlide>
                <SwiperSlide>
                  <Image
                    height={"100%"}
                    width={"100%"}
                    src={units?.floor_plan || ""}
                    fallback="data:image/png;base64,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"
                    alt="Thumbnail"
                    className="w-full h-full object-contain rounded-md"
                  />
                </SwiperSlide>
              </Swiper>
            </div>
            <div className="absolute top-1 right-1 flex flex-col items-center justify-center gap-3  bg-black bg-opacity-30 rounded-lg p-[10px] z-50 ">
              <Badge
                color="success"
                variant="dot"
                invisible={Boolean(!data?.notes?.length)}
              >
                <svg
                  onClick={() => handleNotesModalOpen(data)}
                  width="24"
                  height="24"
                  viewBox="0 0 48 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="pl-[2px]"
                >
                  <g clip-path="url(#clip0_244_2628)">
                    <path
                      d="M38.8395 34.7453V46.0349C38.8395 48.274 37.04 50.0895 34.8208 50.0895H5.24626C3.027 50.0895 1.22754 48.274 1.22754 46.0349V5.62104C1.22754 3.38195 3.027 1.56641 5.24626 1.56641H34.8196C37.0388 1.56641 38.8383 3.38195 38.8383 5.62104V18.6816"
                      stroke="#FFFFFF"
                      stroke-width="3"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                    <path
                      d="M10.5796 14.1465H29.4875"
                      stroke="#FFFFFF"
                      stroke-width="3"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                    <path
                      d="M10.5796 25.8301H29.4875"
                      stroke="#FFFFFF"
                      stroke-width="3"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                    <path
                      d="M10.5796 37.5098H23.2875"
                      stroke="#FFFFFF"
                      stroke-width="3"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                    />
                    <path
                      d="M29.6777 36.5211L31.1482 32.9012L43.7727 20.1602L45.5489 21.7751V21.9534L32.879 34.7353L29.6777 36.5211Z"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M46.3428 17.6919C46.6374 17.6262 46.7835 17.6881 47.0155 17.8491C47.1186 17.921 47.871 18.7495 47.9275 18.8473C48.3743 19.6176 46.6288 20.6678 46.2373 21.2499L44.5569 19.4752C45.0172 19.1557 45.885 17.7934 46.3428 17.6919Z"
                      fill="#FFFFFF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_244_2628">
                      <rect
                        width="48"
                        height="51"
                        fill="white"
                        transform="translate(0 0.328125)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </Badge>

              {Boolean(data?.favorite) ? (
                <svg
                  onClick={() => updateFavorite(data?.id)}
                  width="24"
                  height="24"
                  viewBox="0 0 55 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.8175 0.853648C18.8011 0.184999 24.3306 3.08558 27.4604 8.19022C37.5988 -7.12371 59.3791 3.17535 54.224 21.2629C50.8977 32.9302 36.6138 44.4614 27.4604 51.7515C18.439 44.5357 4.06918 33.0231 0.761325 21.5106C-1.92669 12.1371 2.59936 1.99283 12.8175 0.853648Z"
                    fill="#FF0000"
                  />
                </svg>
              ) : (
                <svg
                  onClick={() => updateFavorite(data?.id)}
                  width="24"
                  height="24"
                  viewBox="0 0 55 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.9841 1.72132C8.38837 2.23368 5.12144 4.74391 3.27037 8.18226C1.40076 11.655 0.956535 16.126 2.203 20.4733C3.75038 25.8579 7.94796 31.3928 13.0377 36.5674C17.7564 41.3647 23.0987 45.713 27.4622 49.2086C31.8794 45.681 37.2359 41.3077 41.9544 36.4774C47.0383 31.2731 51.2234 25.6936 52.7815 20.2286C55.1577 11.891 51.3407 5.53616 45.9266 2.92948C40.5163 0.324638 33.3556 1.37987 28.7112 8.39521C26.1817 3.71205 18.355 1.12114 12.9841 1.72132Z"
                    stroke="#FFFFFF"
                    stroke-width="3"
                    // fill="#FFFFFF"
                  />
                </svg>
              )}

              {Boolean(data?.hidden) ? (
                <svg
                  onClick={() => hideUnits(data?.id)}
                  width="24"
                  height="24"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="25.6912"
                    cy="25.7771"
                    r="23.9998"
                    stroke="#FFFFFF"
                    stroke-width="3"
                  />
                </svg>
              ) : (
                <svg
                  onClick={() => hideUnits(data?.id)}
                  width="24"
                  height="24"
                  viewBox="0 0 52 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="26"
                    cy="26"
                    r="24"
                    stroke="#FFFFFF"
                    stroke-width="3"
                  />

                  <line
                    x1="10"
                    y1="42"
                    x2="42"
                    y2="10"
                    stroke="#FFFFFF"
                    stroke-width="3"
                  />
                </svg>
              )}
            </div>
          </div>

          {/* Custom Pagination Dots */}
          <div className="custom-pagination py-4">
            {[...Array(totalSlides)].map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => swiperInstance?.slideTo(index)}
              ></span>
            ))}
          </div>

          {/* Bottom Section - Property Details */}
          <div className="flex flex-col text-center p-2 mt-2 mb-6">
            <div>
              {data?.units?.property?.year_built >= 2025 && <div className="flex justify-center py-2"><span className="bg-green-600 text-white text-sm font-semibold px-2 py-1 rounded-md leading-none">
    New Construction
  </span></div>}
              <div className="flex justify-center items-start gap-2">
              <a
                href={property?.website || "#"}
                target="_blank"
                className="text-3xl font-playfair font-semibold underline underline-offset-0.5 decoration-[1px] p-0 m-0 leading-none text-wrap"
              >
                {data?.title_text || ""}
              </a>
  </div>
              <p className="text-[18px] my-3 font-inter">
                {data?.sub_market_bd_ba_sqft_text || ""}
              </p>

              {/* <div className="text-xl justify-center font-inter flex gap-1 items-center font-bold">
                {data?.special_price_text?.trim()?.length ? (
                  <>
                    <span className="line-through">
                      {data?.price_text || ""}
                    </span>
                    <span className="ml-2">
                      {data?.special_price_text || ""}
                    </span>
                  </>
                ) : (
                  <span className="">{data?.price_text || ""}</span>
                )}
              </div> */}
            </div>

            <div className="text-lg mt-4 flex flex-col gap-2">
              {data?.special_calc_text?.trim()?.length ? (
                <p className="">{data?.special_calc_text || ""}</p>
              ) : null}

               <div className="text-xl justify-center font-inter flex gap-1 items-center font-bold">
                {data?.special_price_text?.trim()?.length ? (
                  <>
                    <span className="line-through">
                      {data?.price_text || ""}
                    </span>
                    <span className="ml-2">
                      {data?.special_price_text || ""}
                    </span>
                  </>
                ) : (
                  <span className="">{data?.price_text || ""}</span>
                )}
              </div>

              <p className="text-xl">{data?.unit_model_text || ""}</p>
              <p className="text-xl ">
                {data?.availability_holdtime_text || ""}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharedPropertyCardMobile;
